import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { z as z$1 } from "zod";

// src/models/tellescope.ts
const availabilitySlotDataSchema = z$1.object({
	durationInMinutes: z$1.number(),
	priority: z$1.number(),
	startTimeInMS: z$1.number(),
	userId: meta(z$1.string(), { pii: { category: "identifier" } })
});
const availabilitySlotsSchema = z$1.object({
	id: zodFlavorId(),
	availabilityBlocks: z$1.array(availabilitySlotDataSchema),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});
const availabilitySlotDataWithDayOfWeekSchema = availabilitySlotDataSchema.extend({
	startDate: z$1.any().transform((date) => new Date(date)),
	startDateString: z$1.string()
});
const TellescopeAvailabilitySlots = defineFirestoreCollection("tellescope_availability_slots", availabilitySlotsSchema, void 0, {
	dwReplication: true,
	firestoreCollectionPath: "tellescope_availability_slots"
});
const availabilitySlotCustomerDraftsSchema = z$1.object({
	customerDrafts: z$1.record(z$1.string(), z$1.object({
		selectedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate),
		slotId: z$1.string()
	})),
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});

export { TellescopeAvailabilitySlots, availabilitySlotCustomerDraftsSchema, availabilitySlotDataSchema, availabilitySlotDataWithDayOfWeekSchema, availabilitySlotsSchema };
//# sourceMappingURL=tellescope.mjs.map